import { render } from "./call-us.vue?vue&type=template&id=d33623ac"
import script from "./call-us.vue?vue&type=script&lang=js"
export * from "./call-us.vue?vue&type=script&lang=js"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__